// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","content":"styles_content__coKLY","submit":"styles_submit__aLxcw"};